import React, { Component } from 'react'
import { UPDATE_USER_QUERY, USERS_QUERY } from "../../queries/Queries"
import { useMutation, useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import User from './User';
import { AUTH_TOKEN } from '../../constants';
import { FaLock, FaLockOpen, FaSave, FaSortDown, FaSortUp } from 'react-icons/fa';
import { flattenStrapiData } from '../../utils/utilities';
import { IconButton } from '@mui/material';

class UserList extends Component {
  state = {
    locked: true,
    error: "",
    columns: {
      "id": { direction: "asc" },
      "username": { direction: "", filter: "" },
      "email": { direction: "", filter: "" },
      "user_points": { direction: "", type: "number", isEditAble: true },
      "fullname": { direction: "", filter: "" },
      "address.country.name": { direction: "asc" },
      "blocked": { direction: "", type: "boolean" },
      "confirmed": { direction: "", type: "boolean"},
      "deleted_since": { direction: "", type: "date" },
      "delete_reason": { direction: "" },
    },
    sortBy: "id:asc",
    filters: {
    }
  }


  onChangeFilter(e, incKey) {
    let columns = this.state.columns;
    let value = e.target.value
    let filters = {

    }
    for(let key of Object.keys(columns)) {
      if('filter' in columns[key]) {
        columns[key].filter = key === incKey ? value : ""
        filters[key] = { containsi: columns[key].filter }
      }
    }
    this.setState({columns, filters})
  }

  handleLockChange(e) {
    this.setState({locked: !this.state.locked});
  }

  updateColumn(incKey) {    
    let columns = this.state.columns
    for(let key of Object.keys(columns)) {
      if('direction' in columns[key]) {
        if(key === incKey) {
          if(columns[incKey].direction === 'asc') {
            columns[incKey].direction = 'desc'
          } else {
            columns[incKey].direction = 'asc'
          }
        } else {
          columns[key].direction = ''
        }
      }
    }

    let sortBy =  incKey + ":" + columns[incKey].direction
    this.setState({
      columns: columns,
      sortBy: sortBy
    })
  }
  
  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

  
  
    function getArrow(direction) {
      switch(direction) {
        case "asc":
          return <FaSortUp/>;
        case "desc":
          return <FaSortDown/>
        default:
          return <span>-</span>
      }
    }

    let columns = this.state.columns
    let columnHeaders = []
    for(let key of Object.keys(columns)) {
      let canFilter = 'filter' in columns[key]
      columnHeaders.push((<th key={key} onClick={() => this.updateColumn(key)}>
          <div>
            <h4>{key}</h4>
            
            {canFilter ? 
              <form><input  
              value={columns[key].filter}  
              onChange={(e) => this.onChangeFilter(e, key)} 
              onClick={(e) => e.stopPropagation()}/></form>
            : ""}
  
            {getArrow(columns[key].direction)}
          </div>
        </th>))
    }
    let locked = this.state.locked
    return (
      <div>
        <IconButton onClick={this.handleLockChange.bind(this)} >{locked ? <FaLock/> : <FaLockOpen/> }</IconButton>
        <br/>
        <div><span className="error">{this.state.error}</span></div>
        <table className="table table-bordered">
          <thead>
            <tr>
              {columnHeaders.map((header) => header)}
              {!locked && <th><h4>Edit</h4></th>}
            </tr>
          </thead>
          <tbody>
              <GetData 
                locked={locked}
                columns={this.state.columns}
                sortBy={this.state.sortBy}
                filters={this.state.filters}/>
          </tbody>
        </table>
      </div>
    )
  }
}

function GetData({columns, locked, sortBy, filters}) {
  const {data, loading, error, refetch} = useQuery(USERS_QUERY, {variables: {sortBy: sortBy, filters: filters}})
  
  let columnSize = Object.keys(columns).length
  if(loading) return(<tr><td colSpan={columnSize}><CircularProgressIndicator size={60} /></td></tr>)

  if(error) {   
    console.log("Some error", error)
    return(<tr><td colSpan={columnSize}><span className="error">{error.message}</span></td></tr>)
  }

  let users = data?.usersPermissionsUsers?.data
  
  return users && users.map(user => {
    user = flattenStrapiData(user)
    return<User 
      key={user.id} 
      locked={locked} 
      user={user} 
      columns={columns}>
      <Update refetch={() => refetch()}/>
    </User>
  })
}

function Update({id, state, refetch}) {
  const [upadateUser, {loading, error}] = useMutation(UPDATE_USER_QUERY)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) {
    console.log("ERROR:"+error)
    alert("Update Mutation Error: "+ error.message)
  }
  return (
      <IconButton onClick={e => { 
      upadateUser({variables: {id: id, user_points: state.user.user_points}})
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))
    }
    }><FaSave/></IconButton>
  )
}

export default UserList